import SpotlightFeature from './models/SpotlightFeature';
import { ToolConfig } from './types';
import config from './config.json';

const AppConfig = {
  ...config,
  tools: config.tools as ToolConfig[],
  features: config.features.map((feature) => SpotlightFeature.fromJson(feature)),
  problemSolveReceiveURL: 'https://datacenter-pdx.aka.amazon.com/#/inbound/problem_solve_receiving',
};

export default AppConfig;
